import { Link } from '@cian/components';
import * as React from 'react';
import { IOfficialRepresentativeAgent } from '../../../../../api/bs_centers';
import { isArrayWithItems } from '../../../../../utils';
import { getFormattedPhoneNumber } from '../../../../../utils/format';

const styles = require('./index.css');

export interface IOfficialRepresentativeProps {
  agent: IOfficialRepresentativeAgent;
}

export interface IOfficialRepresentativeState {
  isPhonesVisible: boolean;
}

export class OfficialRepresentative extends React.PureComponent<
  IOfficialRepresentativeProps,
  IOfficialRepresentativeState
> {
  public state = {
    isPhonesVisible: false,
  };

  public render() {
    return (
      <div className={styles['official-representative']}>
        Официальный представитель:{' '}
        <strong>
          {this.props.agent.name}・{this.showPhones()}
        </strong>
      </div>
    );
  }

  private showPhones = () => {
    const { agent } = this.props;

    if (!isArrayWithItems(agent.visiblePhones)) {
      return null;
    }

    if (this.state.isPhonesVisible) {
      return agent.visiblePhones
        .map(({ countryCode, code, number: phoneNumber }) =>
          getFormattedPhoneNumber({
            countryCode,
            number: `${code}${phoneNumber}`,
          }),
        )
        .join(', ');
    } else {
      return (
        <Link linkStyle={styles['link']} href="#" onClick={this.toggleIsPhonesVisible}>
          Показать телефон
        </Link>
      );
    }
  };

  // tslint:disable-next-line:no-any
  private toggleIsPhonesVisible = (e: any) => {
    e.preventDefault();
    this.setState({
      isPhonesVisible: !this.state.isPhonesVisible,
    });
  };
}
